// « Tous les équipements » (CDC retours du 08/10, lot I, #630) — ce que l'écran et le PDF
// partagent sans charger le composant (`EquipementsTable`, chargé à la demande).
//
// Le CDC l'appelait « equ-7 » : l'id est pris (Patrimoine, section du socle rangée en `cul`),
// la section est donc `equ-9`, propre à l'arborescence v2 (`tagging.SECTIONS_V2_SEULEMENT`).
// Section du socle SANS tuile : le serveur la sert « hors champ » ; l'écran monte la table à la
// place de l'avis, le PDF imprime la phrase ci-dessous (la table est interactive : filtres,
// pagination, exports — l'imprimer serait imprimer des milliers de lignes).
export const SECTION_TOUS_EQUIPEMENTS = 'equ-9'

export const IMPRESSION_TOUS_EQUIPEMENTS =
  "Table interactive de tous les équipements de la commune (INSEE, BPE 2025) : comptes par type " +
  "comparés à l'intercommunalité et au département, et liste de chaque équipement — à consulter " +
  "en ligne, avec ses exports Excel et CSV ; elle n'est pas reprise dans l'étude PDF."
